import {
  DateListener,
  getDarkLogoPath,
  getLanguages,
  getLightLogoPath,
} from '@zenlayer/portal-utils';
import { ThemeAutoSwitchHOC } from '@zenlayer/zen-design/esm/hooks/useThemeSwitch';
import { ItemType, MenuItemType } from '@zenlayer/zen-design/esm/menu';
import { getLocale, setLocale } from '@zenlayer/zen-intl18';
import React from 'react';
export {
  getApiDocsUrl,
  getContactUsSales,
  getContactUsSupport,
  getCopywritingTag,
  getIsChiefPartner,
  getIsDefaultPartner,
  getIsHarmonyPartner,
  getIsTelinPartner,
  getPartnerCode,
  getRegistrationContent,
  getRemittanceContent,
  getThemes,
} from '@zenlayer/portal-utils';

export const lightLogoUrl = new DateListener<'LIGHTLOGOURL', string>(
  'LIGHTLOGOURL',
  undefined,
  getLightLogoPath()
);

export const darkLogoUrl = new DateListener<'DARKLOGOURL', string>(
  'DARKLOGOURL',
  undefined,
  getDarkLogoPath()
);

export const HasTextLogo = (props?: React.ImgHTMLAttributes<unknown>) => {
  const lightUrl = lightLogoUrl.useValueListener();
  const darkUrl = darkLogoUrl.useValueListener();

  return (
    <ThemeAutoSwitchHOC
      dark={<img alt="" {...props} src={darkUrl} />}
      light={<img alt="" {...props} src={lightUrl} />}
    />
  );
};

export const languagesDate = new DateListener(
  'LANGUAGES',
  undefined,
  getLanguages()
);

const language_en_menuItem: ItemType = {
  key: 'en',
  label: 'English',
  onClick: () => {
    getLocale() !== 'en' && setLocale('en');
  },
};
const language_zh_menuItem = {
  key: 'zh',
  label: '中文',
  onClick: () => {
    getLocale() !== 'zh' && setLocale('zh');
  },
};
export const useLanguages = () => {
  const languages = languagesDate.useValueListener();
  React.useEffect(() => {
    if (!languages.includes(getLocale())) {
      setLocale(languages[0]);
    }
  }, [languages]);
  const languageMenuItems = React.useMemo(() => {
    let _items: MenuItemType[] = [];
    if (languages.includes('en')) {
      _items = [..._items, language_en_menuItem];
    }
    if (languages.includes('zh')) {
      _items = [..._items, language_zh_menuItem];
    }
    return _items;
  }, [languages]);
  return {
    languages,
    showLanguageButton: languages.length > 1,
    languageMenuItems,
  };
};
